import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  standalone: false,
})
export class SearchInputComponent implements OnInit {
  // Search form and fields
  catalogSearchForm: FormGroup;
  query: string;

  @Input() hideSearchBlock = false; // Default hide the search collapse when not used in the header
  @Input() searchPlaceholderMessage = 'Search catalog';
  @Output() sendSearchQuery = new EventEmitter<string>();
  @Output() inputValueChange = new EventEmitter();
  @Input() searchQueryData = '';

  @ViewChild('searchQuery', { static: true }) searchQueryField: ElementRef;

  constructor() {}

  /**
   * On Init create the search form group and form control
   * Also check if hide search block is enabled to be false, this is the case where the
   * search field should not be collapsible (ex. search page)
   */
  ngOnInit(): void {
    this.catalogSearchForm = new FormGroup({
      catalogSearchQuery: new FormControl(''),
    });
  }

  /**
   * On Search emit the search query on click and enter
   */
  onSearch(): void {
    // Get the search query from the form group element value
    const query = this.catalogSearchForm.value.catalogSearchQuery;

    // Emit search query to be handled by another component
    this.sendSearchQuery.emit(query);
  }

  /**
   * Change the state of search on change and emit input value change, but do not trigger a search
   * @param queryValue returns the query value
   */
  onChange(queryValue): void {
    this.searchQueryData = queryValue;
    this.inputValueChange.emit(queryValue);
  }
}
